import React from 'react';
import { PEIImage, PEIRecordsInfo } from '@/common';
import styles from '@/styles/OfficesComponent.module.scss';

export const OfficesComponent = ({
  institutionName,
  start,
  end,
  address,
}: {
  institutionName: string;
  address: string;
  start: number;
  end: number;
}) => {
  return (
    <section className={styles.container}>
      <h3 className={styles.heading}>Offices</h3>
      <section className={styles['location-outer-container']}>
        <summary className={styles['location-container']}>
          <PEIImage src={'./marker.svg'} alt='marker icon' width={23} height={23.58} />
          <span className={styles.address}>{address}</span>
        </summary>
      </section>

      <PEIRecordsInfo
        start={start}
        end={end}
        institutionName={institutionName}
        componentName='offices'
      />
    </section>
  );
};
